export default __webpack_public_path__ + "static/media/garage6.ba9ee14a.jpg";